module.exports = __webpack_public_path__ + "img/04.634e5657.png";